<template>
    <div class="mvt-localhighlightscore grid md-grid-cols-4" :class="{ 'xs-only': xsOnly }" v-if="getData.length">
        <template v-for="(item, i) in getData">
            <span>
                <div>
                    <h3 class="f4 text-bold">{{item.title}}</h3>
                </div>
                <mvtChart class="img" :index="i" v-if="item.chartData" :height="90" :width="90" :data="item.chartData"></mvtChart>
            </span>
        </template>
    </div>
</template>

<script src="./mvt-localhighlightscore.js"></script>

<style lang="scss">
    @use "./mvt-localhighlightscore.scss" as *;
</style>